/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import { connect } from 'react-redux';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import getIcons from '../../functions/getIcons/getIcons';
import ThemeNineTitle from '../common/ThemeNineTitle';

const ThemeNineMendozaTnCScreen = props => {
  let operator = props && props.home && props.home.operator;
  const createMarkup = data => {
    return {
      __html: data,
    };
  };

  const ahumadaBody = () => {
    return (
      <div className="mendoza-terms">
        <p>
          <span class="bold-orange">1.- </span>Realizar declaración jurada de Migraciones Argentinas
          on line con 48 horas de anticipación en el siguiente enlace{' '}
          <a href="https://ddjj.migraciones.gob.ar/app/home.php" target="_blank">
            https://ddjj.migraciones.gob.ar/
          </a>
          .
        </p>

        <p>
          <span class="bold-orange">2.- </span>Pasajeros Argentinos y residentes en Argentina, no
          requieren PCR.
        </p>

        <p>
          <span class="bold-orange">3.- </span>Argentinos que no tienen esquema completo de
          vacunación deben presentar PCR y realizar cuarentena obligatoria de 7 días una vez
          llegados a su destino.
        </p>

        <p>
          <span class="bold-orange">4.- </span>Chilenos requieren seguro de viaje.
        </p>

        <p>
          <span class="bold-orange">5.- </span> Modalidades de compra en
          https://www.recorrido.cl/ahumada-internacional/es o directamente en terminales.
        </p>

        <p>
          <span class="bold-orange">6.- </span> Niños mayores a 6 años deben tener esquema completo
          de vacunación.
        </p>

        <p className="bold-text">
          Por lo anterior, la persona que requiera el servicio de transporte, deberá cumplir con
          cada uno de esos requisitos, y además deberá firmar la declaración jurada que Buses
          Ahumada ha preparado para estos efectos.
        </p>

        <p className="bold-text">
          El rechazo por parte de la autoridad migratoria Argentina para ingresar a su país, es de
          única y exclusiva responsabilidad de cada pasajero, lo que no otorga derecho a reembolso o
          compensación alguna.
        </p>
      </div>
    );
  };

  return props.home.operator ? (
    <div className="themes-theme-nine-mendoza-tnc-screen">
      <KuposHelmet />

      <div style={{ position: 'relative', marginTop: -130 }}>
        {operator && operator.operator == 'busesahumada' ? (
          <HeroSection
            // height={'30vh'}
            heroImage={getIcons('tncMendozaBanner')}
            title={'Requisitos para viajar a Mendoza'}
            description={'Home / Términos y condiciones / Requisitos para viajar a Mendoza'}
          />
        ) : (
          <HeroSection
            // height={'30vh'}
            heroImage={getIcons('tncBanner')}
            title={'Términos y condiciones '}
            description={'Home / Términos y condiciones '}
          />
        )}
      </div>

      {operator && operator.operator == 'busesahumada' ? (
        <ThemeNineTitle title={'¿Qué necesitas para viajar a Mendoza?'} />
      ) : (
        <ThemeNineTitle title={'Términos y condiciones'} />
      )}

      <div className="mendoza-container">
        {operator && operator.operator == 'busesahumada' ? (
          ahumadaBody()
        ) : (
          <div
            className="about-us-content font12"
            dangerouslySetInnerHTML={createMarkup(operator && operator.terms)}
          />
        )}
      </div>
    </div>
  ) : null;
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeNineMendozaTnCScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNineMendozaTnCScreen.js